import { Injectable, Injector, forwardRef, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { PopupService } from './popup.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/Rx';
import { Observable } from 'rxjs';
import { LoaderService } from './loader.service';

@Injectable()
export class PropertyService {

  myProperties: any[] = [];
  pageNumber: number = 1;
  recordsPerPage: number = 10;
  allFetched: boolean = false;
  searchValue: string = '';
  isFetching: boolean = false;
  isDeletedFetching: boolean = false;

  myDeletedProperties: any[] = [];
  deletedPageNumber: number = 1;
  allDeletedFetched: boolean = false;
  deletedSearchValue: string = '';

  propertiesContainerElement: any;
  propertiesInputElement: any;

  fetchPropertiesSource = new BehaviorSubject<boolean>(false);
  fetchPropertiesStream = this.fetchPropertiesSource.asObservable();

  constructor(public httpClient: HttpClient, public popupService: PopupService,
              public loaderService : LoaderService) { }

  getMyProperties() {
    return this.httpClient.get(environment.APP.API_URL+'/my/property?recordsPerPage=' +
     this.recordsPerPage + '&pageNumber=' + this.pageNumber + '&name=' + encodeURIComponent(this.searchValue))
    .map((res: any) => {
      (res.length === this.recordsPerPage) ? this.pageNumber++ : this.allFetched = true;
      return res;
    });
  }

  getMyDeletedProperties() {
    return this.httpClient.get(environment.APP.API_URL+'/my/property?deleted=true&recordsPerPage=' +
     this.recordsPerPage + '&pageNumber=' + this.deletedPageNumber + '&name=' + encodeURIComponent(this.deletedSearchValue))
    .map((res: any) => {
      (res.length === this.recordsPerPage) ? this.deletedPageNumber++ : this.allDeletedFetched = true;
      return res;
    });
  }

  goToProperty(property) {
    let center, polygon, w = (<any>window);
    if(property.geom.type === 'Point') {
      center = new w.google.maps.LatLng(property.geom.coordinates[1],property.geom.coordinates[0]);
    } else if(property.geom.type === 'MultiPolygon') {
      polygon = new w.google.maps.Polygon({
        path: w.getPolygonPaths(property.geom.coordinates[0][0]),
      });
      center = w.getPolygonCenter(polygon);
    }
    w.map.setOptions({
      center: center,
      zoom: 18
    });
    this.popupService.updateRoute();
  }

  resetPagination() {
    this.allFetched = false;
    this.myProperties = [];
    this.pageNumber = 1;
  }

  resetDeletedPagination() {
    this.allDeletedFetched = false;
    this.myDeletedProperties = [];
    this.deletedPageNumber = 1;
  }

  searchProperties() {
    this.resetPagination();
    this.fetchProperties();
  }

  fetchProperties() {
    if (!this.allFetched && !this.isFetching) {
      let w = (<any>window);
      this.isFetching = true;
      this.loaderService.addGreyLoaderClass();
      this.getMyProperties().subscribe((response)=> {
        this.isFetching = false;
        for(let i = 0; i < response.length; i++) {
          if(response[i].geom.type === 'Point') {
            response[i].position = new w.google.maps.LatLng(response[i].geom.coordinates[1],response[i].geom.coordinates[0]);
          } else if(response[i].geom.type === 'MultiPolygon') {
            response[i].polygon = new w.google.maps.Polygon({
              path: w.getPolygonPaths(response[i].geom.coordinates[0][0]),
            });
            response[i].position = w.getPolygonCenter(response[i].polygon);
          }
          this.myProperties.push(response[i]);
          var globalId = response[i].globalId ? response[i].globalId : null;
          if(!this.myProperties[this.myProperties.length-1].mainPhotoPreviewUrl) {
            this.myProperties[this.myProperties.length-1].mainPhotoPreviewUrl = environment.APP.API_URL + '/image-service/property/streetview/'+ response[i].id
            +'/image?globalId=' + globalId + '&width=119&height=88&defaultImg=true';
          }
          !this.propertiesInputElement && this.addInputEventObservable();
        }
        this.loaderService.removeGreyLoaderClass();
        w.Events.publish('detectChanges');
      },(error)=>{
        this.isFetching = false;
        this.loaderService.removeGreyLoaderClass();
        w.Events.publish('detectChanges');
        throw(error);
      });
    }
  }

  addInputEventObservable() {
    this.propertiesInputElement = document.getElementById('properties-search-input');
    if(this.propertiesInputElement) {
      Observable.fromEvent(this.propertiesInputElement, 'input')
      .debounceTime(500)
      .subscribe((event)=> {
        this.searchProperties();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/property.service.ts